// Thin wrapper around the Telegram WebApp SDK.
// SDK is loaded by <script> tag in index.html and exposed as window.Telegram.WebApp.

declare global {
  interface Window {
    Telegram?: {
      WebApp: TelegramWebApp;
    };
  }
}

interface TelegramWebApp {
  initData: string;
  initDataUnsafe: {
    user?: { id: number; first_name?: string; username?: string };
    [k: string]: unknown;
  };
  colorScheme: 'light' | 'dark';
  themeParams: Record<string, string>;
  HapticFeedback?: {
    impactOccurred: (style: 'light' | 'medium' | 'heavy') => void;
    notificationOccurred: (type: 'error' | 'success' | 'warning') => void;
  };
  showAlert: (msg: string) => void;
  showConfirm: (msg: string, cb: (ok: boolean) => void) => void;
  ready: () => void;
  expand: () => void;
  close: () => void;
  BackButton: {
    show: () => void;
    hide: () => void;
    onClick: (cb: () => void) => void;
    offClick: (cb: () => void) => void;
  };
}

export function tg(): TelegramWebApp | undefined {
  return window.Telegram?.WebApp;
}

export function getInitData(): string {
  return tg()?.initData ?? '';
}

export function getUserDisplay(): string {
  const u = tg()?.initDataUnsafe?.user;
  if (!u) return 'Guest';
  return u.first_name || u.username || `User ${u.id}`;
}

export function haptic(kind: 'success' | 'error' | 'light' = 'light') {
  const h = tg()?.HapticFeedback;
  if (!h) return;
  if (kind === 'light') h.impactOccurred('light');
  else h.notificationOccurred(kind);
}

export function alert(msg: string) {
  const t = tg();
  if (t?.showAlert) t.showAlert(msg);
  else window.alert(msg);
}

export function confirm(msg: string): Promise<boolean> {
  return new Promise((resolve) => {
    const t = tg();
    if (t?.showConfirm) t.showConfirm(msg, resolve);
    else resolve(window.confirm(msg));
  });
}
